import React, { useEffect, useState } from "react";
import { callAPI } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import { confirmToast } from "../utils/confirmToast";
import useConfirmModal from "../hooks/useConfirmModal";
import useRequirePermission from "../hooks/useRequirePermission";
import ValidatePinModal from "./modals/ValidatePinModal";
import { useNavigate } from "react-router-dom";
import { isOfflineAndroid } from '../utils/androidOfflineCart';
import { getOfflineTableCheckout, getOfflineOrderCheckout } from '../utils/offlineCheckout';


import CartImage from "./Image";

export default function CheckoutItems({
  orderTypeNum,
  orderId,
  tableId,
  refreshKey,
  onCartSelectionChange = () => {},
  splitPaymentActive,
  onSplitPaymentChange = () => {},
  splitType,
  onSplitTypeChange,
  splitCount,
  onSplitCountChange,
  cashAmount,
  onCashAmountChange = () => {},
  freezeSplitControls = false,
  onOrderNameChange = () => {},
}) {
  const [items, setItems] = useState([]);
  const [dealItems, setDealItems] = useState([]);
  const [halfAndHalfItems, setHalfAndHalfItems] = useState([]);
  const [selectedCartIds, setSelectedCartIds] = useState([]);
  const { confirm, ConfirmModalRenderer } = useConfirmModal();
  const { requirePermission, permissionModalProps } = useRequirePermission();
  const navigate = useNavigate();
  
  const handleAddMoreItems = (e) => {
    e.preventDefault();
  
    const orderType =
      orderTypeNum == 1 || orderTypeNum == 2
        ? "takeaway"
        : orderTypeNum == 3 || orderTypeNum == 4
        ? "dinein"
        : null;
  
    // existing_order_id only - deliberately NOT edit_order_id. Sending edit_order_id here (as
    // this used to) made every add-to-cart call attach the new item straight into this order's
    // cart_ids (CartService::addSelectedDishesToCart), and then Send to Kitchen created a second
    // (child) order via existing_order_id and attached the same item to that too - same item
    // billed on both orders. This was the PREPAID "Add More Items" duplicate. existing_order_id
    // alone still drives both the child-order link on send and the cart display on Takeaway.js
    // (displayOrderId) - nothing is lost by dropping edit_order_id.
    if (orderType == "dinein") {

      navigate("/takeaway", {
        state: {
          orderType: orderType,
          selectedTables:  tableId ? [tableId] : null,
          existing_order_id: orderId,
        },
      });

      return;
    }

    navigate("/takeaway", {
      state: {
        orderType: orderType,
        selectedTables: {},
        existing_order_id: orderId,
     //   selected_table_ids: tableId ? [tableId] : null,
      },
    });
  };
  

  const getDeleteAuthFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
  
    if (params.get("validated") !== "1") return null;
  
    const itemId = params.get("item_id");
    const resDetail = params.get("resDetail");
  
    if (!itemId || !resDetail) return null;
  
    const [del_item_id, , del_emp_id] = resDetail.split("_");
  
    return {
      itemId: Number(itemId),
      del_item_id: Number(del_item_id),
      del_emp_id: Number(del_emp_id)
    };
  };
  

  
  
  useEffect(() => {
    const del_auth = getDeleteAuthFromUrl();
    if (!del_auth) return;
  
    deleteCartItem(del_auth.itemId, del_auth);
  }, []);
  

  const fetchCheckoutDishDetails = async () => {
    try {


        if (isOfflineAndroid()) {

          if (tableId) {

            const data =
              await getOfflineTableCheckout(tableId);

            setItems(data.items);
            setDealItems(data.data_deals);
            setHalfAndHalfItems(
              data.data_half_and_half
            );
            onOrderNameChange(
              data.order_name
            );

            return;
          }

          if (orderId) {

            const data = await getOfflineOrderCheckout(orderId);

            setItems(data.items);
            setDealItems(data.data_deals);
            setHalfAndHalfItems(
              data.data_half_and_half
            );
            onOrderNameChange(
              data.order_name
            );

            return;
          }
        }


      let apiUrl = apiUrls.CHECKOUT_DISH_DETAILS;

      if (tableId) apiUrl += `?table_id=${tableId}`;
      else if (orderId) apiUrl += `?order_id=${orderId}`;

      const response = await callAPI(apiUrl, {}, "GET");
      const data = response?.data?.data || {};

        console.log(
          '[OFFLINE UI] ABOUT TO SET ITEMS:',
           data.items.length,
           JSON.stringify(data.items, null, 2)
        );
      setItems(data.items || []);
      console.log('[OFFLINE UI] SET ITEMS DONE')
      
      setDealItems(data.data_deals || []);
      setHalfAndHalfItems(data.data_half_and_half || []);
      onOrderNameChange(data.order_name || "");
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  useEffect(() => {
    fetchCheckoutDishDetails();
  }, [orderId, tableId, refreshKey]);

  
  useEffect(() => {
  console.log(
    '[OFFLINE UI] ITEMS STATE:',
    items.length,
    items
  );
}, [items]);



  const anyItemPaid =
    items.some(i => i.item_paid) ||
    dealItems.some(d => d.item_paid) ||
    halfAndHalfItems.some(h => h.item_paid);

  useEffect(() => {
    if (anyItemPaid) {
      onSplitPaymentChange(true);
      setSelectedCartIds([]);
      onCartSelectionChange([]);
    }
  }, [anyItemPaid]);

  const toggleSplitPayment = () => {
    const newValue = !splitPaymentActive;
    onSplitPaymentChange(newValue);

    if (!newValue) {
      setSelectedCartIds([]);
      onCartSelectionChange([]);
    }
  };



  const toggleItemSelection = (id) => {
    const updated = selectedCartIds.includes(id)
      ? selectedCartIds.filter(x => x !== id)
      : [...selectedCartIds, id];

    setSelectedCartIds(updated);
    onCartSelectionChange(updated);
  };

  

  const deleteCartItem = async (cartId, del_auth = null) => {

    if (splitPaymentActive && !del_auth) {
      const proceed = await confirm({
        title: "Split Payment Warning",
        message:
          "Deleting items during split payment may affect discount or surcharge amounts. Continue?",
        confirmText: "Yes, Delete",
        confirmClass: "btn-danger"
      });
    
      if (!proceed) return;
    }
    // Restaurants that have opted into staff PIN login authorize the delete inline (a manager-
    // permission PIN prompt right here, tagging the deletion to whoever entered it) instead of
    // round-tripping through the old employee clock-in/clock-out screen. Everyone else keeps the
    // clockin-clockout flow unchanged below - staff_login_enabled is off for a restaurant that
    // hasn't set up staff roles yet, and gating on it avoids locking out item deletion for a
    // restaurant with nobody assigned a Manager/Admin role.
    const staffLoginEnabled = localStorage.getItem('staff_login_enabled') === '1';
    let employeeId = null;

    if (orderTypeNum == 3 && !del_auth && staffLoginEnabled) {
      const { authorized, employeeId: authEmployeeId } = await requirePermission('order.delete_item');
      if (!authorized) return;
      employeeId = authEmployeeId;
    } else if (orderTypeNum == 3 && !del_auth) {
      const proceed = await confirm({
        title: "PIN Authentication Required",
        message: "Authenticate with your PIN to delete this item.. Continue?",
        confirmText: "Authenticate",
        confirmClass: "btn-primary"
      });

      if (!proceed) return;

      window.location.href =
        `/clockin-clockout?tbtl=${tableId}&itid=${cartId}`;
      return;
    }


    try {
      const payload = {
        id: cartId,
        from: "payment-page",
        orderType: orderTypeNum,
        edit_order_id:orderId
      };
      if (del_auth) {
        payload.del_item_id = del_auth.del_item_id;
        payload.del_emp_id = del_auth.del_emp_id;
      } else if (employeeId) {
        payload.del_emp_id = employeeId;
      }
  
      const response = await callAPI(
        apiUrls.REMOVE_CART_ITEM,
        {},
        "POST",
        payload
      );
  
      if (response?.data?.status) {
        await fetchCheckoutDishDetails();
        setSelectedCartIds([]);
        onCartSelectionChange([]);
      }
    } catch (error) {
      console.error("Delete item failed:", error);
    } finally {
      const cleanUrl =
        window.location.pathname + (tableId ? `?table_id=${tableId}` : "");
      window.history.replaceState({}, "", cleanUrl);
    }
  };
  
  

  return (
    <>
      {/* 3 = dine-in (existing), 1 = takeaway (phone orders, Quick Checkout) - delivery/
          UberEats/DoorDash/Menulog stay unable to split, matching the backend's
          OrdersController::actionOrderPayment() guard (isDineIn() || isTakeAway()). */}
      {(orderTypeNum == 3 || orderTypeNum == 1) && (
        <div className="d-flex justify-content-end mb-2">
          <div className="form-check form-switch mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              checked={splitPaymentActive}
              disabled={anyItemPaid || freezeSplitControls}
              onChange={toggleSplitPayment}
            />
            <label className="form-check-label">Split Payment</label>
          </div>
        </div>
      )}
{splitPaymentActive && !anyItemPaid && (
  <div className="d-flex justify-content-end mb-2 align-items-center gap-3">
    
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="splitType"
        id="splitItem"
        value="item"
        checked={splitType == "item"} 
        onChange={() => onSplitTypeChange("item")}
        disabled={freezeSplitControls}
      />
      <label className="form-check-label" htmlFor="splitItem">
        Select Items
      </label>
    </div>

    
    <div className="form-check form-check-inline d-flex align-items-center gap-2">
      <input
        className="form-check-input"
        type="radio"
        name="splitType"
        id="splitEqual"
        value="equal"
        checked={splitType == "equal"} 
        onChange={() => onSplitTypeChange("equal")}
        disabled={freezeSplitControls}
      />
      <label className="form-check-label" htmlFor="splitEqual">
        Equal Split
      </label>

      
      {splitType === "equal" && (
        <select
          className="form-select form-select-sm"
          value={splitCount} 
          onChange={(e) => onSplitCountChange(Number(e.target.value))}
          disabled={freezeSplitControls}
        >
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <option key={n} value={n}>
              {n} {n === 1 ? "split" : "splits"}
            </option>
          ))}
        </select>
      )}
    </div>

    <div className="form-check form-check-inline d-flex align-items-center gap-2">
      <input
        className="form-check-input"
        type="radio"
        name="splitType"
        id="splitCashEftpos"
        value="cash_eftpos"
        checked={splitType == "cash_eftpos"}
        onChange={() => onSplitTypeChange("cash_eftpos")}
        disabled={freezeSplitControls}
      />
      <label className="form-check-label" htmlFor="splitCashEftpos">
        Cash + EFTPOS
      </label>

      {splitType === "cash_eftpos" && (
        <input
          type="number"
          className="form-control form-control-sm"
          style={{ width: '110px' }}
          placeholder="Cash amount"
          min="0"
          step="0.01"
          value={cashAmount}
          onChange={(e) => onCashAmountChange(e.target.value)}
          disabled={freezeSplitControls}
        />
      )}
    </div>
  </div>
)}




      <div className="cardStyle">
        <div className="table-responsive">
          <table className="table tableStyle align-middle">
            <tbody>

              

            {dealItems.map(deal => (
    <React.Fragment key={deal.cid}>
    <tr>
    <td>
    {splitPaymentActive &&
  splitType === "item" &&
  !deal.item_paid &&
  !deal.item_deleted && (
    <input
      type="checkbox"
      checked={selectedCartIds.includes(deal.item_id)}
      onChange={() => toggleItemSelection(deal.item_id)}
    />
)}

          </td>

      <td className="tableProImgCol align-top" >
        <CartImage
          src={deal.product_thumbnail}
          alt={deal.item_name}
          imgClass="tableProImg"
        />
      </td>

      <td>
        <span className="proName d-block">{deal.item_name}</span>
        <span
          className="proDetail"
          dangerouslySetInnerHTML={{ __html: deal.productDetails }}
        />
      </td>

      <td className="text-end">${deal.totalwithdeals.toFixed(2)}</td>

      <td className="text-end">
        {!deal.item_paid && !deal.item_deleted ? (
          <button
            className="actionIcon"
            onClick={() => deleteCartItem(deal.cart_id)}
          >
            <svg width="20" height="20">
              <use xlinkHref="./images/sprite.svg#iconTrash" />
            </svg>
          </button>
         ) : (
          <span style={{ color: "#555", fontStyle: "italic" }}>
            {deal.item_paid && deal.item_deleted
              ? "(Paid & Deleted)"
              : deal.item_paid
              ? "(Paid)"
              : "(Deleted)"}
          </span>
        )}
      </td>
    </tr>

    
    {Array.isArray(deal[deal.cid]) && deal[deal.cid].length > 0 && (
      <tr >
        <td colSpan={5}     >
             <div
        style={{
          paddingLeft: 48       
        }}
      >
          {deal[deal.cid].map((nested, i) => (
            <div
              key={nested.cart_id || i}
              className="cartPannel1 d-flex align-items-start"
              style={{ marginBottom: 10 }}
            >
              <div className="tableProImgCol">
                <CartImage
                  src={nested.product_thumbnail}
                  alt={nested.item_name}
                  imgClass="tableProImg"
                />
              </div>

              <div className="cartTitleCol1 flex-grow-1 ms-2">
                <span className="d-block">
                  {nested.selected_size
                    ? `${nested.item_name} - ${nested.selected_size}`
                    : nested.item_name}
                </span>

                <div
                  dangerouslySetInnerHTML={{ __html: nested.dealIngrade }}
                />
                <div
                  dangerouslySetInnerHTML={{ __html: nested.dealUpgrade }}
                />
                {nested.comments && (
                  <span className="proDetail d-block fst-italic">Comment: {nested.comments}</span>
                )}
              </div>

              <div className="cartImgPrice text-end ms-2">
                ${nested.total_price.toFixed(2)}
              </div>
            </div>
          ))}
          </div>
        </td>
      </tr>
    )}

  </React.Fragment>
))}

{halfAndHalfItems.map(hnh => (
    <React.Fragment key={hnh.cid}>
    <tr>
    <td>
    {splitPaymentActive &&
  splitType === "item" &&
  !hnh.item_paid &&
  !hnh.item_deleted && (
    <input
      type="checkbox"
      checked={selectedCartIds.includes(hnh.item_id)}
      onChange={() => toggleItemSelection(hnh.item_id)}
    />
)}

          </td>

      <td className="tableProImgCol align-top" >
        <CartImage
          src={hnh.product_thumbnail}
          alt={hnh.item_name}
          imgClass="tableProImg"
        />
      </td>

      <td>
        <span className="proName d-block">{hnh.item_name}</span>
        {hnh.crust_label && (
          <span className="proDetail d-block">Crust: {hnh.crust_label}(${hnh.crust_price})</span>
        )}
      </td>

      <td className="text-end">${hnh.total_price.toFixed(2)}</td>

      <td className="text-end">
        {!hnh.item_paid && !hnh.item_deleted ? (
          <button
            className="actionIcon"
            onClick={() => deleteCartItem(hnh.cart_id)}
          >
            <svg width="20" height="20">
              <use xlinkHref="./images/sprite.svg#iconTrash" />
            </svg>
          </button>
         ) : (
          <span style={{ color: "#555", fontStyle: "italic" }}>
            {hnh.item_paid && hnh.item_deleted
              ? "(Paid & Deleted)"
              : hnh.item_paid
              ? "(Paid)"
              : "(Deleted)"}
          </span>
        )}
      </td>
    </tr>

    {Array.isArray(hnh[hnh.cid]) && hnh[hnh.cid].length > 0 && (
      <tr>
        <td colSpan={5}>
             <div style={{ paddingLeft: 48 }}>
          {hnh[hnh.cid].map((half, i) => (
            <div
              key={half.cart_id || i}
              className="cartPannel1 d-flex align-items-start"
              style={{ marginBottom: 10 }}
            >
              <div className="tableProImgCol">
                <CartImage
                  src={half.product_thumbnail}
                  alt={half.item_name}
                  imgClass="tableProImg"
                />
              </div>

              <div className="cartTitleCol1 flex-grow-1 ms-2">
                <span className="d-block">
                  {half.selected_size
                    ? `${half.item_name} - ${half.selected_size}`
                    : half.item_name}
                </span>
                {half.product_detail_text && (
                  <span dangerouslySetInnerHTML={{ __html: half.product_detail_text }} />
                )}
                {half.toppings && half.toppings.map(topping => (
                  <span key={topping.group} className="proDetail d-block">
                    {topping.group}: {topping.label}(${topping.price})
                  </span>
                ))}
                {half.comments && (
                  <span className="proDetail d-block fst-italic">Comment: {half.comments}</span>
                )}
              </div>

              <div className="cartImgPrice text-end ms-2">
                ${half.total_price.toFixed(2)}
              </div>
            </div>
          ))}
          </div>
        </td>
      </tr>
    )}

  </React.Fragment>
))}

              {items.map(item => (
                <tr
                  key={item.item_id}
               
                >
                  <td>
                  {splitPaymentActive &&
  splitType === "item" &&
  !item.item_paid &&
  !item.item_deleted && (
    <input
      type="checkbox"
      checked={selectedCartIds.includes(item.item_id)}
      onChange={() => toggleItemSelection(item.item_id)}
    />
)}

                    </td>

                  <td className="tableProImgCol">
                    <CartImage
                      src={item.product_thumbnail}
                      alt={item.product_name}
                      imgClass="tableProImg"
                    />
                  </td>

                  <td>
                    <span className="proName d-block">
                      {item.product_size
                        ? `${item.product_name} - ${item.product_size}`
                        : item.product_name}
                      {item.quantity > 1 && (
                        <span className="proQty">&nbsp;&times;{item.quantity}</span>
                      )}
                    </span>
                    <span
                      className="proDetail"
                      dangerouslySetInnerHTML={{
                        __html: item.product_detail
                      }}
                    />
                    {item.comments && (
                      <span className="proDetail d-block fst-italic">
                        Comment: {item.comments}
                      </span>
                    )}
                  </td>

                  <td className="text-end">${item.total_price.toFixed(2)}</td>

                  <td className="text-end">
                  {!item.item_paid && !item.item_deleted ? (
                      <button
                        className="actionIcon"
                        onClick={() => deleteCartItem(item.item_id)}
                      >
                        <svg width="20" height="20">
                          <use xlinkHref="./images/sprite.svg#iconTrash" />
                        </svg>
                      </button>
                     ) : (
                      <span style={{ color: "#555", fontStyle: "italic" }}>
                        {item.item_paid && item.item_deleted
                          ? "(Paid & Deleted)"
                          : item.item_paid
                          ? "(Paid)"
                          : "(Deleted)"}
                      </span>
                    )}
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>
      </div>
      <div className="row justify-content-end mt-3">
  <div className="col-auto">
    <a
      href="#"
      className="btn iconBtn btnPrimary"
      onClick={handleAddMoreItems}
    >
      <span>Add More Items</span>

      <svg width="20" height="20" className="btnIcon">
        <use xlinkHref="./images/sprite.svg#iconNextArrow"></use>
      </svg>
    </a>
  </div>
</div>
      <ConfirmModalRenderer />
      <ValidatePinModal {...permissionModalProps} />
    </>
  );
}
